import React from 'react';
import './fancyLoader.css';

type FancyLoaderProps = {
  className?: string;
  label?: string | null;
  sizePx?: number;
};

export const FancyLoader: React.FC<FancyLoaderProps> = ({
  className = '',
  label = 'Laddar data…',
  sizePx = 65,
}) => {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <div
        className="fancy-loader"
        style={{ ['--loader-size' as any]: `${sizePx}px` }}
        aria-hidden="true"
      />
      {label ? (
        <div className="text-sm font-medium text-slate-600 dark:text-slate-300">{label}</div>
      ) : null}
    </div>
  );
};


